'use client';

import { c as _c } from "react/compiler-runtime";
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { theme } from '@cc-shopping/ui/theme';
import { Box, Button, useMediaQuery } from '@mui/material';
import { type FormEvent, startTransition } from 'react';
import { useShallow } from 'zustand/shallow';
import { BalanceTransferDetailsForm } from './BalanceTransferDetailsForm';
import { useBTCalculatorStore } from './calculatorStore';
import { ExistingDebtForm } from './ExistingDebtForm';
export const BalanceTransferCalculatorForm = () => {
  const $ = _c(12);
  const {
    calculate: calculate_0
  } = useBTCalculatorStore(useShallow(_temp));
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = theme.breakpoints.down("sm");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isMobile = useMediaQuery(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      actionName: "calculator_interacted",
      actionType: "submit",
      actionSection: "balance_transfer_calculator",
      impressionSection: "in_content"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const firePageAction = usePageAction(t1);
  let t2;
  if ($[2] !== calculate_0 || $[3] !== firePageAction || $[4] !== isMobile) {
    t2 = e => {
      e.preventDefault();
      startTransition(() => {
        const isValid = calculate_0();
        const graphElement = document.getElementById("balance-transfer-calculator-graph");
        if (isValid && isMobile && graphElement) {
          graphElement.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      });
      firePageAction({
        action_location_url: window.location.href
      });
    };
    $[2] = calculate_0;
    $[3] = firePageAction;
    $[4] = isMobile;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleSubmit = t2;
  let t3;
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "column",
      gap: 3
    };
    t4 = <ExistingDebtForm />;
    t5 = <BalanceTransferDetailsForm />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button type="submit" style={{
      marginTop: 3
    }} disableRipple={true} disableFocusRipple={true} disableTouchRipple={true}>Calculate</Button>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== handleSubmit) {
    t7 = <Box component="form" onSubmit={handleSubmit} sx={t3}>{t4}{t5}{t6}</Box>;
    $[10] = handleSubmit;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
function _temp(t0) {
  const {
    calculate
  } = t0;
  return {
    calculate
  };
}